import {
  getComposer,
  getConductor,
  getCopyrightP,
  getFeature,
  getFormate,
  getLabelName,
  getLicensor,
  getOrchestraChoir,
  getPrimaryArtists,
  getReleaseTitle,
  getSeries,
  getSinger,
  getTrackTitle,
} from "../actions/suggest";

export const mapToSelect = (data: any[]): any => {
  return data?.map((item) => {
    return {
      label: item.label,
      value: item.value,
    };
  });
};

export const getReleaseTitleOptions = async (keyword: string, data: any[]) => {
  const trackTitleData = await getReleaseTitle(keyword);
  const list = trackTitleData?.result?.list;
  if (Array.isArray(list)) {
    return list;
  } else {
    console.error("Unexpected format for release title data:", trackTitleData);
    return [];
  }
};

// export const getPrimaryArtistsOptions = async (
//   keyword: string,
//   data: any[]
// ) => {
//   const filteredOptions = data.filter((title: any) =>
//     title.label.toLowerCase().includes(keyword.toLowerCase())
//   );
//   return filteredOptions;
// };

// export const getArtistRoleOpotions = async (keyword: string) => {
//   const artistRole = await getArtistRole(keyword);
//   return artistRole.result.list;
// };

export const getFormateOptions = async (keyword: string) => {
  const format = await getFormate(keyword);
  return format.result;
};

// export const getClientListByYearOPtions = async (keyword: string) => {
//   const clientByYear = await getClientListByYear(keyword);
//   return clientByYear.result.list;
// };

export const getSingerOptions = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getSinger(inputValue) || [])?.result?.list || []);
};

export const getComposerOptions = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getComposer(inputValue) || [])?.result?.list || []);
};

export const getConductorOptions = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getConductor(inputValue) || [])?.result?.list || [])
};

export const getOrchestraChoirOptions = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getOrchestraChoir(inputValue) || [])?.result?.list || []);
}

export const getSeriesOptions = async (keyword: string) => {
  const series = await getSeries(keyword);
  return series.result.list;
};

export const getTrackTitleOptions = async (keyword: string, data: any[]) => {
  const trackTitleData = await getTrackTitle(keyword);
  const list = trackTitleData?.result?.list;

  if (Array.isArray(list)) {
    return list;
  } else {
    console.error("Unexpected format for track title data:", trackTitleData);
    return [];
  }
};

export const getFeatureOptions = async (keyword: string, data: any[]) => {
  const filteredOptions = data.filter((title: any) =>
    title.label.toLowerCase().includes(keyword.toLowerCase())
  );
  return filteredOptions;
};

export const getGenreOptions = async (keyword: string, data: any[]) => {
  const filteredOptions = data.filter((title: any) =>
    title.label.toLowerCase().includes(keyword.toLowerCase())
  );
  return filteredOptions;
};

export const getsubGenreOptions = async (keyword: string, data: any[]) => {
  const filteredOptions = data.filter((title: any) =>
    title.label.toLowerCase().includes(keyword.toLowerCase())
  );
  return filteredOptions;
};

// Latest changes for dropdown loader
export const getPrimaryArtistsOptionsFromApi = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getPrimaryArtists(inputValue) || [])?.result?.list || []);
};

export const getCopyrightPOptionsFromApi = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getCopyrightP(inputValue) || [])?.result?.list || []);
};

export const getLicensorOPtionsFromApi = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getLicensor(inputValue) || [])?.result?.list || []);
};

export const getFeatureOptionsFromApi = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getFeature(inputValue) || [])?.result?.list || []);
};

export const getLableNameOptionsFromApi = async (
  inputValue: string,
  callback: (options: any) => void
) => {
  callback((await getLabelName(inputValue) || [])?.result?.list || []);
};
